/**
 * Detect Internet Explorer 11 or Edge
 */
( function( w, d, $ ) {

    /**
     * Detect IE 11
     */
    function isIE11() {
        var isIE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
        if ( isIE11 ) {
            d.body.classList.add('is-ie');
        } else {
            d.body.classList.add('not-ie');
        }
    }
    isIE11();

    /**
     * Detect Edge
     */
    function isIEorEDGE(){
      if (navigator.appName == 'Microsoft Internet Explorer'){
        return true; // IE
      }
      else if(navigator.appName == "Netscape"){                       
        return navigator.appVersion.indexOf('Edge') > -1; // EDGE
      }       
      return false;
    }
    var edge = isIEorEDGE();
    function edgeCase( isIEorEDGE ) {
        if ( isIEorEDGE ) {
            document.body.classList.add('is-edge');
            if ( document.body.classList.contains('is-ie11') ) {
                document.body.classList.remove('is-ie11');
            }
        } else {
            document.body.classList.add('not-edge');
        }
    }
    edgeCase( edge );

} )( window, document, jQuery );